const b64DecodeUnicode = (str: string) =>
  decodeURIComponent(
    atob(str).replace(/(.)/g, (m, p) => {
      let code = (p as string).charCodeAt(0).toString(16).toUpperCase();
      if (code.length < 2) {
        code = '0' + code;
      }
      return '%' + code;
    }),
  );

const base64UrlDecode = (str: string) => {
  let output = str.replace(/-/g, '+').replace(/_/g, '/');
  switch (output.length % 4) {
    case 0:
      break;
    case 2:
      output += '==';
      break;
    case 3:
      output += '=';
      break;
    default:
      // eslint-disable-next-line no-console
      console.error('JWT base64 string is not of the correct length');
  }

  try {
    return b64DecodeUnicode(output);
  } catch {
    return atob(output);
  }
};

export const logJwtClaim = (token: string) => {
  const part = token.split('.')[1];
  try {
    const decoded = JSON.parse(base64UrlDecode(part));
    // eslint-disable-next-line no-console
    console.log(
      'Token claim: ',
      decoded['https://rtkwlf.io/email'],
      decoded['sub'],
    );
  } catch {
    // eslint-disable-next-line no-console
    console.error('Token claim: Invalid JWT');
  }
};
